import styled, { css } from "styled-components";

const LogoStyled = styled.div`
    padding: 0 0 3.2rem;
    width: 20rem;
    position: relative;

    ${props => props.collapsed && css`
        width: 6.4rem;
        transition: width 0.3s ease-in-out;
    `}
`;

export { LogoStyled };
